/* global common */
import { sendAmplitudeEvent, getBreakpointMinWidth } from '@html/_common/utils';

export default function AOPaxTravelers(stickyMenu) {
  this.common = {};
  if (typeof sendAmplitudeEvent !== 'undefined') {
    this.common = { sendAmplitudeEvent, getBreakpointMinWidth };
  } else {
    this.common = common;
  }
  this.stickyMenu = stickyMenu;

  const SELECTOR_PAX_TRAVELERS = '.js-ao-pax-travelers';
  const SELECTOR_PAX_TRAVELERS_DROPDOWN = '.js-ao-pax-travelers__dropdown-toggle';
  const MOBILE_WIDTH = this.common.getBreakpointMinWidth('m2') - 1;
  const SELECTOR_PAX_ADULT = '.js-ao-pax-selector-adult';
  const SELECTOR_PAX_ADULTS = '.js-ao-pax-selector-adults';
  const SELECTOR_PAX_ADULTS_NUMBER = '.js-ao-pax-selector-adults-number';
  const SELECTOR_PAX_CHILDREN = '.js-ao-pax-selector-children';
  const SELECTOR_PAX_CHILDREN_ONE = '.js-ao-pax-selector-children-one';
  const SELECTOR_PAX_CHILDREN_MORE = '.js-ao-pax-selector-children-more';
  const SELECTOR_PAX_CHILDREN_NUMBER = '.js-ao-pax-selector-children-more-number';

  const isInMobileWidth = (width) => width <= MOBILE_WIDTH;

  const getDeviceType = (width) => {
    if (isInMobileWidth(width)) {
      return 'mobile';
    }
    return 'desktop';
  };

  const isMobileDevice = () => getDeviceType($(window).width()) === 'mobile';
  const isDesktopDevice = () => getDeviceType($(window).width()) === 'desktop';

  const closeOpenMenu = () => {
    $(SELECTOR_PAX_TRAVELERS).each(function () {
      const $component = $(this);
      const $menu = $component.find('.js-ao-pax-travelers__dropdown-toggle');

      // Run the close-up code only when the menu is open
      if (!$menu.hasClass('hid')) {
        $menu.addClass('hid'); // hide the dropdown
        $component.find('.ao-pax-selector__arrow') // reset the arrow
          .removeClass('ao-pax-selector__arrow--rotated');
      }
    });
  };
  const handleOutsideClick = (e) => {
    // Bail out if the click was inside the component
    if ($(e.target).closest(SELECTOR_PAX_TRAVELERS).length) return;

    // Otherwise, close only the components whose menus are actually open
    closeOpenMenu();
  };
  const showMenu = (e) => {
    const $currentTarget = $(e?.currentTarget);
    const $dropdown = $currentTarget.find(SELECTOR_PAX_TRAVELERS_DROPDOWN);

    // Close any other dropdowns with the same class that are not children of the current target
    $(SELECTOR_PAX_TRAVELERS_DROPDOWN).not($dropdown).addClass('hid');
    $(SELECTOR_PAX_TRAVELERS).find('.ao-pax-selector__arrow').not($currentTarget.find('.ao-pax-selector__arrow')).removeClass('ao-pax-selector__arrow--rotated');

    if (!$(e.target).closest($dropdown).length) {
      $dropdown.toggleClass('hid');
      $currentTarget.find('.ao-pax-selector__arrow').toggleClass('ao-pax-selector__arrow--rotated');
    }
  };

  const updatePaxData = (paxData) => {
    if (paxData.numberOfAdults === 1) {
      $(SELECTOR_PAX_ADULT).removeClass('hid');
      $(SELECTOR_PAX_ADULTS).addClass('hid');
    } else if (paxData.numberOfAdults > 1) {
      $(SELECTOR_PAX_ADULTS_NUMBER).text(paxData.numberOfAdults);
      $(SELECTOR_PAX_ADULT).addClass('hid');
      $(SELECTOR_PAX_ADULTS).removeClass('hid');
    }

    if (paxData.numberOfChildren === 0) {
      $(SELECTOR_PAX_CHILDREN).addClass('hid');
    } else if (paxData.numberOfChildren === 1) {
      $(SELECTOR_PAX_CHILDREN).removeClass('hid');
      $(SELECTOR_PAX_CHILDREN_ONE).removeClass('hid');
      $(SELECTOR_PAX_CHILDREN_MORE).addClass('hid');
    } else if (paxData.numberOfChildren > 1) {
      $(SELECTOR_PAX_CHILDREN_NUMBER).text(paxData.numberOfChildren);
      $(SELECTOR_PAX_CHILDREN).removeClass('hid');
      $(SELECTOR_PAX_CHILDREN_ONE).addClass('hid');
      $(SELECTOR_PAX_CHILDREN_MORE).removeClass('hid');
    }

    if (paxData.numberOfAdults) {
      $(SELECTOR_PAX_TRAVELERS).attr('data-pax-adults', paxData.numberOfAdults);
    }

    if (paxData.numberOfChildren) {
      $(SELECTOR_PAX_TRAVELERS).attr('data-pax-children', paxData.numberOfChildren);
    } else {
      $(SELECTOR_PAX_TRAVELERS).attr('data-pax-children', 0);
    }
  };

  const listenToPaxChanges = () => {
    $(document).on('paxSelection:travelersChange', (_, paxData) => {
      if (isDesktopDevice()) {
        closeOpenMenu();
      }
      if (isMobileDevice()) {
        this.stickyMenu.closeStickyMenu();
      }
      updatePaxData(paxData);
    });
  };

  this.initiate = () => {
    listenToPaxChanges();
    if (isDesktopDevice()) {
      $(document).on('click', SELECTOR_PAX_TRAVELERS, showMenu);
      $(document).on('click', handleOutsideClick);
    }
    if (isMobileDevice()) {
      $(document).on('click', SELECTOR_PAX_TRAVELERS, (event) => {
        const dataPlacement = $(event.currentTarget).attr('data-placement');
        const dataEventName = $(event.currentTarget).attr('data-event-name');
        this.stickyMenu.openStickyMenu();
        $('.js-ao-pax-travelers-sheet').attr('data-placement', dataPlacement);
        $('.js-ao-pax-travelers-sheet').attr('data-event-name', dataEventName);
      });
    }
  };
}
